import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import 'moment-duration-format';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnalyticsConstants } from '../../../shared/constants/Analytics';
import { Interactions } from '../../../shared/constants/Interactions';
import { ArchiveLeadInput } from '../../../shared/models/lead/archiveLead.input';
import { MakeCallInput } from '../../../shared/models/lead/makeCall.input';
import { RolType } from '../../../shared/models/types/rol.types';
import { CalendarComuService } from '../../../shared/services/calendar/calendar-comu.service';
import { CompanyService } from '../../../shared/services/company/company.service';
import { FormsService } from '../../../shared/services/forms/forms.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { AuthService } from '../../../shared/services/security/auth.service';
import { TrackAnalyticsService } from '../../../shared/services/track-analytics/track-analytics.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';
import { ErrorFormatter } from './../../../shared/formatter/error.formatter';

@Component({
  selector: 'ngx-call-modal',
  templateUrl: './call-modal.component.html',
  styleUrls: []
})
export class CallModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('content', { static: false }) content: Element;

  intervalCall: any;
  inCall: boolean;
  durationCall: string;
  hasError: boolean;
  leadInCall: any;
  contactPhone: any;
  canCall: boolean;

  finishCallForm: FormGroup;
  callStartTime: any;

  needNextStep: boolean;
  stepInteraction: number;

  IN_CALL = 1;
  IN_INTERACTION = 2;
  archivedForm: FormGroup;
  archiveLeadInput: ArchiveLeadInput = new ArchiveLeadInput();
  interactionSelected: string;
  activeForm: FormGroup;
  leadId: string;
  radioGroupForm: FormGroup;
  reportTime: any;
  Interactions = Interactions;
  dateModel: moment.Moment = moment();
  secondsDuractionCall: number;

  rolType: RolType = new RolType();
  assigmentMethodType: string;

  usersSelected = [];

  returnedDataSubcribe: any;
  userLeadId: any;
  needConfirm: boolean;
  errorNoEvent = true;

  private readonly TOKEN_CALL_ERROR = 'toaster.call.error';
  private readonly TOKEN_ABRV_SECONDS = 'time.abrv_seconds';
  private readonly TOKEN_ABRV_MINUTES = 'time.abrv_minutes';
  canStopCall: boolean;
  removeEventSubscription: any;
  eventRemovedSubscription: any;
  activateInteractionSubscription: any;
  sending: boolean;
  isTransitionNewToOnTrack: any;
  isVisitConfirmation: any;
  eventToConfirm: any;
  interactionActivated = false;
  prequalificationEmptyEvent = false;
  comingFromCallModal = true;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly translateService: TranslatorService,
    private readonly spinner: NgxSpinnerService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly formsService: FormsService,
    private readonly trackAnalytics: TrackAnalyticsService,
    private readonly calendarComuService: CalendarComuService,
    private readonly authService: AuthService,
    private readonly companyService: CompanyService,
  ) {
    this.activeForm = this.formBuilder.group({});
    this.activeForm.setErrors([Validators.required]);
  }

  ngOnInit(): void {
    clearInterval(this.intervalCall);
    this.intervalCall = null;
    this.finishCallForm = this.formsService.initFinishCallForm();
    this.isTransitionNewToOnTrack = false;
    this.isVisitConfirmation = false;

  }

  get f(): any {
    return this.finishCallForm.controls;
  }
  ngOnDestroy(): void {
    this.returnedDataSubcribe.unsubscribe();
    this.removeEventSubscription.unsubscribe();
    this.eventRemovedSubscription.unsubscribe();
    this.activateInteractionSubscription.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.modalsHandler.callModal.subscribe(data => {

      data.comingFromCallModal === false ? this.comingFromCallModal = false : this.comingFromCallModal = true;

      this.getAssignmentMethod();

      this.calendarComuService.eventAdded.subscribe(() => {
        this.errorNoEvent = false;
      });
      this.removeEventSubscription = this.calendarComuService.removeEvent.subscribe(() => {
        this.needConfirm = false;
        this.errorNoEvent = true;
      });
      this.eventRemovedSubscription = this.calendarComuService.eventRemoved.subscribe(() => {
        this.interactionActivated = true;
      });
      this.activateInteractionSubscription = this.calendarComuService.activateInteraction.subscribe(() => {
        this.interactionActivated = false;
      });
      this.returnedDataSubcribe = this.calendarComuService.returnedCalendarData.subscribe((returnedCalendarData: any) => {
        if (returnedCalendarData) {
          this.prequalificationEmptyEvent = false;
          this.activeForm = this.formsService.initCalendarEvent(returnedCalendarData.dateFrom);
          this.activeForm.controls.comments.setValue(returnedCalendarData.comment);
          if (this.interactionSelected !== Interactions.CALENDAR_PREQUALIFICATION) {
            this.activeForm.controls.userId.setValue(returnedCalendarData.userId);
          }
          this.activeForm.controls.type.setValue(returnedCalendarData.type);
          if (this.userLeadId === returnedCalendarData.userId || !this.userLeadId) {
            this.sendInteraction();
          } else {
            this.needConfirm = true;
          }
        } else {
          if (this.interactionSelected === Interactions.CALENDAR_PREQUALIFICATION && this.errorNoEvent) {
            this.prequalificationEmptyEvent = true;
            this.sendInteraction();
          }
        }
        this.spinner.hide();

      });
      this.canStopCall = false;
      this.needConfirm = false;
      this.needNextStep = data.needNextStep;
      this.stepInteraction = this.IN_CALL;
      this.hasError = false;
      this.inCall = false;
      this.contactPhone = data.contactPhone;
      this.leadId = data.leadId;
      this.userLeadId = data.userLeadId;

      if (data.isTransitionNewToOnTrack) {
        this.isTransitionNewToOnTrack = data.isTransitionNewToOnTrack;
      } else if (data.eventToConfirm) {

        this.isVisitConfirmation = true;
        this.eventToConfirm = data.eventToConfirm;
        this.finishCallForm.addControl('visitConfirmationStatus', new FormControl('', Validators.required));

      } else {
        this.isTransitionNewToOnTrack = false;
        this.isVisitConfirmation = false;
        this.checkInCall(data.callStartTime, data.interactionTime);
      }
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false,
          windowClass: 'max-100-vh'
        })
        .result
        .finally(() => {
          this.resetFinishCallForm();
          this.removeVisitConfirmationData();
          this.returnedDataSubcribe.unsubscribe();
          this.interactionSelected = Interactions.NOTHING;
          this.activeForm = this.formBuilder.group({});
          this.activeForm.setErrors([Validators.required]);
          clearInterval(this.intervalCall);
          this.durationCall = '';
          this.reportTime = 0;
          this.secondsDuractionCall = 0;
          this.leadComuService.launchReloadMyLead(this.leadId);
        });
    });
  }

  private getAssignmentMethod() {
    this.companyService.getAssigmentMethod$().subscribe((assigmentMethod: string) => {
      this.assigmentMethodType = assigmentMethod;
    });
  }

  stopCall(): void {

    this.spinner.show();

    if (this.finishCallForm.invalid) {
      this.spinner.hide();

      return;
    }
    if (this.needConfirm && this.finishCallForm.controls.confirmAction.value) {
      this.sendInteraction();
    }
    if (this.interactionSelected === Interactions.CALENDAR || this.interactionSelected === Interactions.CALENDAR_PREQUALIFICATION) {
      this.calendarComuService.getDataCalendarEvent.emit();

    } else {
      this.sendInteraction();
    }
  }

  confirmCreateEvent(): void {
    this.sendInteraction();
  }

  checkInCall(callStartTime?: string, interactionTime?: number): void {
    const makeCallInput = new MakeCallInput();
    makeCallInput.leadId = this.leadId;

    if (callStartTime) {
      this.inCall = true;
      this.setTime(interactionTime);
      this.leadInCall = makeCallInput.leadId;
    } else {
      this.makeCall();
    }
  }

  closeModalGoLead(): void {
    this.leadComuService.launchReloadMyLead(this.leadInCall);
    this.modalService.dismissAll();
  }

  setTime(interactionTime: number): void {
    let interactionTimeCalculated = interactionTime;
    this.intervalCall = setInterval(() => {
      this.canStopCall = true;
      const duration = moment.duration(interactionTimeCalculated, 'seconds');
      this.durationCall = duration.format('HH [h.] mm [min.] ss [seg.]');
      this.secondsDuractionCall = interactionTimeCalculated;
      interactionTimeCalculated += 1;
    }, 1000);
  }

  resetFinishCallForm(): void {
    this.finishCallForm.reset();
  }

  removeVisitConfirmationData(): void {
    if (this.finishCallForm.controls.visitConfirmationStatus) {
      this.finishCallForm.removeControl('visitConfirmationStatus');
    }
    this.eventToConfirm = null;
    this.isVisitConfirmation = false;
  }

  stopCountCall(): void {
    clearInterval(this.intervalCall);
    this.reportTime = moment().toDate().toString();
  }

  initFormArchived(): void {
    this.activeForm = this.formsService.initArchiveForm();
    this.activeForm.controls.comments.setValue('');

    this.interactionSelected = Interactions.ARCHIVE;
  }

  initFormClose(): void {
    this.activeForm = this.formsService.initFormClose();
    this.interactionSelected = Interactions.CLOSE;
  }
  initFormReminder(): void {
    this.activeForm = this.formsService.initCalendarEvent(moment().add(1, 'hours'));
    this.finishCallForm.addControl('confirmAction', new FormControl(false));
    this.interactionSelected = Interactions.CALENDAR;
  }
  initFormReminderPrequalification(): void {
    this.activeForm = this.formsService.initCalendarEvent(moment().add(1, 'hours'));
    this.finishCallForm.addControl('confirmAction', new FormControl(false));
    this.interactionSelected = Interactions.CALENDAR_PREQUALIFICATION;
  }

  initFormVisit(): void {
    this.activeForm = this.formsService.initFormVisit();
    this.interactionSelected = Interactions.VISIT;
  }
  changeArchiveOption(event: any): void {
    this.setArchivedOptionValidators(this.activeForm);
    this.formsService.changeArchiveOption(this.activeForm, event);
  }

  selectDatetoReminder(amount: any, unit: string): void {
    // TODO review method deprecated
    // tslint:disable-next-line
    this.dateModel = moment().add(amount, unit);
    this.activeForm.get('reminderDate').setValue(this.dateModel.format('YYYY-MM-DDTHH:mm'));
  }

  private sendInteraction(): void {
    if (this.interactionActivated) {
      return;
    }
    this.sending = true;
    if (this.isTransitionNewToOnTrack) {
      const transitionToTrackInput = this.formsService.bindForm(this.leadId, Interactions.TRANSITION_TO_ON_TRACK, this.finishCallForm);

      this.formsService.sendTransitionToTrack(transitionToTrackInput)
        .then(() => this.formsService.sendForm(this.leadId, this.interactionSelected, this.activeForm, this.prequalificationEmptyEvent, this.comingFromCallModal))
        .then(() => this.successInteraction())
        .catch(err => this.errorInteraction(err.graphQLErrors))
        .finally(() => this.finalyInteraction());
    } else if (this.isVisitConfirmation) {
      const visitConfirmationInput = this.formsService.bindForm(this.leadId, Interactions.VISIT_CONFIRMATION, this.finishCallForm, this.eventToConfirm.id);
      this.formsService.sendVisitConfirmation(visitConfirmationInput)
        .then(() => this.formsService.sendForm(this.leadId, this.interactionSelected, this.activeForm, this.prequalificationEmptyEvent, this.comingFromCallModal))
        .then(() => this.successVisitConfirmation())
        .catch(err => this.errorInteraction(err.graphQLErrors))
        .finally(() => {
          this.finishCallForm.removeControl('visitConfirmationStatus');
          this.finalyInteraction();
        });

    } else {
      const finishCallInput = this.formsService.bindForm(this.leadId,
        Interactions.FINISH_CALL,
        this.finishCallForm,
        Math.floor(this.secondsDuractionCall));
      this.formsService.sendFinishCallForm(finishCallInput)
        .then(() => this.formsService.sendForm(this.leadId, this.interactionSelected, this.activeForm, this.prequalificationEmptyEvent, this.comingFromCallModal))
        .then(() => this.successInteraction())
        .catch(err => this.errorInteraction(err.graphQLErrors))
        .finally(() => this.finalyInteraction());
    }
  }

  private successInteraction(): void {

    this.modalService.dismissAll();
    this.toasterService
      .showToast(
        'success',
        this.translateService.trans('toaster.call.success'),
        this.translateService.trans('toaster.call.success.body')
      );
  }

  private successVisitConfirmation(): void {
    this.modalService.dismissAll();
    this.toasterService
      .showToast(
        'success',
        this.translateService.trans('toaster.visit_confirmation.success'),
        this.translateService.trans('toaster.visit_confirmation.sucess.body')
      );
  }

  private errorInteraction(err: any): void {
    this.toasterService
      .showToast(
        'error',
        this.translateService.trans(this.TOKEN_CALL_ERROR),
        this.errorFormatter.formatErrors(err)
      );
  }

  private finalyInteraction(): void {
    this.errorNoEvent = true;
    this.sending = false;
    this.modalService.dismissAll();
    clearInterval(this.intervalCall);
    this.intervalCall = null;
    this.resetFinishCallForm();
    this.spinner.hide();
  }

  setArchivedOptionValidators(form: FormGroup) {
    this.archiveLeadInput.comments = '';

    const formControls = form.controls;
    const archivedOption = formControls.archivedOption.value;

    if (archivedOption === 'other') {
      formControls.comments.setValidators([Validators.required]);
    } else {
      formControls.comments.setValidators(null);
    }
  }

  // TODO interactionActivated MakeCall
  private makeCall(): void {
    this.hasError = false;
    const makeCallInput = new MakeCallInput();
    makeCallInput.leadId = this.leadId;
    this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_CONTACT, AnalyticsConstants.MAKE_CALL);
    this.leadService.makeCall$(makeCallInput).subscribe(result => {
      if (result.makeCall.result && result.makeCall.inCallLeadId !== makeCallInput.leadId) {
        this.inCall = true;
        this.setTime(0);
        window.location.href = `tel:${this.contactPhone}`;
      } else {
        this.leadInCall = result.makeCall.inCallLeadId;
        this.hasError = true;
      }
    });

    // TODO review with location and refactor
    // if (this.contactPhone.startsWith('+')) {
    //   phone = this.contactPhone;
    //   this.openDialPhone(phone);
    //   return;
    // }
    // if (this.contactPhone.length === 9) {
    //   phone = '+34' + this.contactPhone;
    //   this.openDialPhone(phone);
    //   return;
    // }
    // if (this.contactPhone.length === 11) {
    //   phone = '+' + this.contactPhone;
    //   this.openDialPhone(phone);
    //   return;
    // }
    // this.openDialPhone(phone);
  }
}
